import { render, staticRenderFns } from "./EconomicStatus.vue?vue&type=template&id=842152a2&"
import script from "./EconomicStatus.vue?vue&type=script&lang=js&"
export * from "./EconomicStatus.vue?vue&type=script&lang=js&"
import style0 from "./EconomicStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports